module.exports = __webpack_public_path__ + "static/media/item_5_5_comp.64beb7c3.png";